import { render, staticRenderFns } from "./AutoCompleteClienti.vue?vue&type=template&id=877542d2&"
import script from "./AutoCompleteClienti.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports